export default "__VITE_ASSET__BQf6f13i__"